import { PaymentType } from '@ui/src';

export interface CheckTransaction {
  paymentType?: PaymentType;
  sum: number;
  senderAccountNumber: string;
  recipientAccountNumber: string;
  currencyId: string;
  caspId?: string;
  info?: string;
  benificiaryBankCountry?: string;
  purposeCode?: string;
}

export enum CheckTransactionStatus {
  RED = 'RED',
  GREEN = 'GREEN',
}

export interface CheckTransactionResult {
  fees: {
    name: string;
    fee: number;
    feeId: string;
    feeBaseCurrency: number;
    targetAccountNumber: string;
  }[];
  status: CheckTransactionStatus;
  value: number;
  totalFee: number;
  totalFeeBaseCurrency: number;
}
